import { observer } from 'mobx-react';
import { useStore } from 'app/context';
import { Button } from '../common/Button';
import { Icon } from '../common/Icon';
import { AgenturModel } from 'app/models/agentur.model';
import { AgtPlanModel } from 'app/stores/agt.plan.store';
import { AudioRecordingModal } from './AudioRecordingModal';
import Config from 'Config';

interface IAudioRecordButton {
	agt: AgenturModel;
	plan: AgtPlanModel;
}

export const AudioRecordButton = observer((props: IAudioRecordButton) => {
	const { uiStore } = useStore();
	const modalId = uiStore.modalIds.audioRecording;

	const onOpen = () => {
		uiStore.showModal(modalId);
	};

	if (!Config.enableTranscriptions) {
		return <></>
	}

	return (
		<>
			<Button type="button" className="button is-primary is-inverted" onClick={onOpen}>
				<Icon iconClass="microphone" /> Aufnahme
			</Button>
			<AudioRecordingModal agt={props.agt} plan={props.plan} />
		</>
	);
});
